import { useMutation } from '@tanstack/react-query'
import { deactivateRoster } from 'api/worker'
import { useAuthContext } from 'components/auth'
import { useOptimisticUpdate } from 'hooks/useOptimisticUpdate'
import { companyRostersKey } from 'queries/company/keys'
import { useCompanyRosters } from 'queries/company/useCompanyRosters'
import { MutationOptions, QueryData } from 'queries/types'

type CompanyRosters = QueryData<typeof useCompanyRosters>

export const useDeactivateRosterMutation = (
  { rosterId }: { rosterId: number },
  options: MutationOptions<typeof deactivateRoster, [CompanyRosters], void> = {}
) => {
  const { company } = useAuthContext()

  return useMutation({
    ...useOptimisticUpdate(options, [
      {
        queryKey: companyRostersKey,
        updater: (_variables, previous) => {
          if (previous === undefined) {
            return previous
          }
          return previous.filter((roster) => roster.id !== rosterId)
        },
      },
    ]),
    mutationFn: () => {
      if (!company?.id) {
        throw new Error('Company ID is required')
      }
      return deactivateRoster(company.id, rosterId)
    },
  })
}
